import { CommissionHistory, PagingResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _CommissionHistoryService {
  public getCommissionHistories(page: number) {
    return HttpService.get<PagingResponse<CommissionHistory>>(
      "/commission-histories",
      { queryParams: { page } }
    );
  }
}

const CommissionHistoryService = new _CommissionHistoryService();

export default CommissionHistoryService;
